module.exports = __webpack_public_path__ + "static/img/global.ed7de539.png";